import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";

import styled from "styled-components";
import axios from "axios";
import Tabs, { TabItem } from "../../ui/Tabs";
import UserReferralsTool from "../../referral/tools/UserReferralsTool";
import { useStorageListener } from "../../../hooks/useStorage";
import UpdateAmbassadorInfoForm from "../forms/UpdateAmbassadorInfoForm";
import toast from "react-hot-toast";
import UserPostsPanel from "../../posts/panels/UserPostsPanel";

export default function AmbassadorSettingsPanel(props) {

    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);

    const uData = useStorageListener("user", {});

    useEffect(() => {
        setLoading(true);
        axios.get("/ambassadors/all").then(d => d.data).then(arr => {
            setUsers(arr);
            setLoading(false);
        });
    }, []);


    return (
        <Wrapper>

            <Heading  >
                Программа "Амбассадоры студтуризма"
            </Heading>

            <p>
                <BackLink href={`/ambassadors/${uData?.id}`} target={'_blank'} >
                    Моя страница
                </BackLink>
            </p>

            <Tabs
                tabs={[
                    {
                        label: "Реферальная программа",
                        content: (
                            <TabItem>
                                <UserReferralsTool
                                    user={uData}
                                />
                            </TabItem>
                        )
                    },
                    {
                        label: "Настройки профиля",
                        content: (
                            <TabItem>
                                <UpdateAmbassadorInfoForm
                                    loading={loading}
                                    {...uData}
                                    onSave={async d => {
                                        setLoading(true);
                                        await axios.put("/users", {
                                            ...d
                                        });
                                        setLoading(false);
                                        toast.success("Изменения сохранены");
                                    }}
                                />
                            </TabItem>
                        )
                    },
                    {
                        label: "Новости",
                        content: (
                            <TabItem>
                                {/*Раздел в разработке*/}
                                <UserPostsPanel
                                    userId={uData?.id}
                                    canAdd={true}
                                    canEdit={true}
                                />
                            </TabItem>
                        )
                    }
                ]}
            />


        </Wrapper>
    );
}

const BackLink = styled.a`
  text-decoration: underline;
  color: ${({ theme }) => theme.grey};
  cursor: pointer;
`;


const Heading = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  text-align: center;
  font-weight: 700;
  font-size: 30px;
  line-height: 50px;
  margin-bottom: 40px;
  @media (max-width: 820px) {
    font-size: 24px;
    line-height: 32px;
    padding-left: 5px;
  }
`;

const Wrapper = styled.div`
  font-family: "Noto Sans", sans-serif;
  box-sizing: border-box;
  width: 100%;
  min-width: 800px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(227, 236, 244);
  border-radius: 8px;
  padding: 40px 30px;
  @media(max-width: 820px) {
    min-width: 0;
    padding: 20px 10px;
  }
`;
